const CAROUSEL_SELECTORS = [
  '.teaser-instagram__swiper',
  '.home-solution-card__swiper',
];

function initCarousels(Swiper) {
  if (document.querySelector('.teaser-instagram__swiper')) {
    new Swiper('.teaser-instagram__swiper', {
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        800: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 5,
          noSwiping: true,
        },
      },
    });
  }

  if (document.querySelector('.home-solution-card__swiper')) {
    new Swiper('.home-solution-card__swiper', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 26,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 1,
        },
        1536: {
          slidesPerView: 3,
        },
      },
      autoplay: {
        delay: 2000,
      },
      navigation: {
        prevEl: '.home-solution-card__navigation--prev',
        nextEl: '.home-solution-card__navigation--next',
      },
    });
  }
}

function loadSwiperAndInit() {
  const runner = () => {
    import('swiper').then(({ default: Swiper }) => {
      requestAnimationFrame(() => initCarousels(Swiper));
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(runner);
  } else {
    setTimeout(runner, 1);
  }
}

export function initSwiper() {
  const targets = CAROUSEL_SELECTORS.map(selector =>
    document.querySelector(selector)
  ).filter(Boolean);

  if (targets.length === 0) {
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          loadSwiperAndInit();
        }
      },
      { rootMargin: '200px' }
    );

    targets.forEach(el => observer.observe(el));

    return;
  }

  window.addEventListener('load', loadSwiperAndInit, { once: true });
}
